var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFromZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 72,
    width: 21,
    height: 72,
    rx: 10.5,
    transform: "rotate(180 47.5 72)",
    fill: "#DFDDEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 46,
    width: 20,
    height: 73,
    rx: 10,
    transform: "rotate(-90 0.5 46)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 46,
    width: 20,
    height: 73,
    rx: 10,
    transform: "rotate(-90 0.5 46)",
    fill: "#6165FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFromZero);
export default __webpack_public_path__ + "static/media/add_from_zero.99eb1c15d70150458a06d555dc484dd8.svg";
export { ForwardRef as ReactComponent };